/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

import BaseComponent from "../../../../base/BaseComponent";
import pic from "../../../allResources/img/video.png";
import {Table, Input, Checkbox, Button, Select, DatePicker, Icon, Popover, Pagination} from "antd";
import Position from '../../components/Position'
import ChoiceType from '../../components/ChoiceType'
import Partake from '../../components/Partake'
import DownLoad from '../../components/DownLoad'
import Delete from "../../components/Delete";
import Rename from "../../components/Rename";
import SetLabel from '../../components/SetLabel'

import {changeSize, formatTime, uuid} from "../../../../utils";
import Move from "../../components/Move";
import '../../style/public.css'
import {Scrollbars} from "react-custom-scrollbars";
import {HEADER_HEIGHT} from "../../../../constants";
import PageTableComponent from '../../components/pageTable/PageTable'
import Detailpage from "../../components/DetailPage";
import $ from "jquery";

export default class MyUpload extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state = {
            typeList: [],//全部类型
            selectType: [],//选中的类型
            searchText: '',//搜索的文字
            backList: [],//返回列表
            startTime: '',//开始时间
            endTime: '',//结束时间
            page: 1,
            size: 10,
            data: [],
            selectedRows: [],
            selectedRowKeys: [],
            modalKey:uuid()

        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.getList()
    }

    render() {
     
        return (
            <div style={{ background: '#ffffff',
                padding: '24px 32px 16px 32px',
                margin: "15px 0 15px 15px",

                position: 'relative',
                borderRadius:5
            }}>
                {/*渲染选择框以及下载 功能*/}
                {this.renderBtn()}
                {/*渲染当前位置*/}
                {/*{this.renderPosition()}*/}
                {/*渲染数据*/}
                {this.renderData()}
            </div>
        )
    }

    renderBtn() {
        let btnNames = ["Partake", "DownLoad", "Delete", "Rename", "SetLabel"];
        return (
            <div style={{display: 'flex'}}>
                <div style={{width: '50%',}}>
                        {this.renderBtnName(btnNames,1,'flex',this.state.selectedRows)}
                </div>
                <div>
                    <ChoiceType onSaveCallback={(searchText, selectType, startTime, endTime) => {
                        this.setState({
                            searchText: searchText,
                            selectType: selectType,
                            startTime: startTime,
                            endTime: endTime,
                            page: 1,
                        }, () => {
                            this.getList()
                        })
                    }}></ChoiceType>
                </div>
            </div>
        )
    }

    renderBtnName=(btnNames,num,status,data)=>{
       let  IsText =false;
       if(num === 2) {
           IsText = true;
       }
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        return(
            <div style={{ display: status,color:newSecondSelectColor}}>
                    {
                        btnNames && btnNames.length > 0 && btnNames.map(item => {
                        let ItemComponent = require(`../../components/${item}.js`);
                        let ItemComponentDefault = ItemComponent.default;
                        return <ItemComponentDefault downloadNeedKey={item=='DownLoad'?'virtualFileId':''} currentId={''} IsDefault={true} text={IsText} current={''} key={item}
                                                     checkArray={data}
                                                     callBack={(currentId, current, checkArray,isRefresh,IsGoToPage) => {
                                                        this.RefreshList(currentId, current, checkArray,isRefresh,IsGoToPage)
                                                     }}/>
                    })
                }
            </div>
        )
    };
    RefreshList=()=>{
         let {page,size,count}=this.state;
         let pageSum =Math.ceil( count/size);
         console.log(this.state.selectedRows)
         let dataLength = this.state.data.length-this.state.selectedRows.length;
            if(dataLength === 0){
                if(pageSum == page){	//最后一页
                    page = page > 1 ? page-1 : 1
                }else{
                    page = page
            }
        }
        this.onChangePage(page,this.state.size)

    }
    renderData() {
        let columns = [
            {
                title: '名称',
                dataIndex: 'name',
                ellipsis: true,
                width: 350,
                render: (text, record) => {
                    let title = text;
                    return (<div style={{display: 'flex',cursor:'pointer'}} onClick={()=>{this.getDetailPage(record)}} title={text}>
                            <img src={record.icon} style={{width: '24px', height: '24px', objectFit: "contain"}}/>
                            <div title={title} className={'twoText'} style={{ marginLeft: '8px'}}>{text}</div>
                    </div>)
                }
            },
            {
                title: '上传时间',
                dataIndex: 'createTime',
                render: (text, record) => {
                    return (<div>{formatTime(text)}</div>)
                }
            },
            {
                title: '大小',
                dataIndex: 'size',
                render: (text, record) => {
                    return (<div>{text > 0 ? changeSize(text) : 0 + 'b'}</div>)
                }
            },
            {
                title: '目录',
                dataIndex: 'path',
                width: '300',
                render: (text, record) => {
                    let name = [];
                    if (text && text.length) {
                        text.forEach((item, index) => {
                            name.push(item.name)
                        })
                    }
                    return (<div title={name.join('/')} className={'twoText'}>{name.join('/')}</div>)
                }
            },
            {
                title: '操作',
                dataIndex: 'address',
                render: (text, record) => {
                    let array = []
                    array.push(record)
                   let btn =[ "Delete", "Rename", "SetLabel"]
                    let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
                    const content = (
                        <div style={{color:newSecondSelectColor ,lineHeight: '40px'}}>
                            {
                                btn && btn.length > 0 && btn.map(item => {
                                let ItemComponent = require(`../../components/${item}.js`);
                                let ItemComponentDefault = ItemComponent.default;
                                return <ItemComponentDefault currentId={''} IsDefault={true} text={true} current={''} key={item}
                                checkArray={array}
                                hideCallBack={()=>{this.handleVisibleChange(record)}}
                                callBack={(currentId, current, checkArray,isRefresh,IsGoToPage) => {

                                        if (this.state.data.length === 1) {
                                            this.onChangePage(this.state.page - 1, this.state.size)
                                        } else {
                                            this.onChangePage(this.state.page, this.state.size)
                                        }


                            }}/>
                            })
                            }
                        </div>
                    );
                    let ellipsisBtn=['Partake','DownLoad']
                    return (<div style={{color: '#0050B3', display: 'flex'}}>
                        <span style={{cursor: "pointer", marginRight: '10px',color:newSecondSelectColor}}  onClick={()=>{this.getDetailPage(record,-1)}}>查看</span>
                        {this.renderBtnName(ellipsisBtn,2,'flex',array)}
                        <Popover placement="right"
                                 content={content}
                                 trigger="click" onVisibleChange={() => this.handleVisibleChange(record)}
                                 visible={record.moreVisible}>
                            <div onClick={() => {
                                this.handleVisibleChange.bind(this)
                            }}>
                                <Icon type="ellipsis" style={{marginTop: 5, marginRight: 10,cursor:'pointer',color:newSecondSelectColor}}/>
                            </div>
                        </Popover>

                    </div>)
                }
            },
        ];

        const {selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.state.selectedRowKeys = selectedRowKeys;
                this.state.selectedRows = selectedRows;
                this.setState({})
            },
        };

        return (
            <>
                <PageTableComponent columns={columns}
                                    rowSelection={rowSelection}
                                    data={this.state.data}
                                    page={this.state.page}
                                    size={this.state.size}
                                    count={this.state.count}
                                    onChangePage={(page, size) => {
                                        this.onChangePage(page, size)
                                    }}
                ></PageTableComponent>

                <Detailpage   key={this.state.modalKey} onRef={(Detailpage) => this.setDetailpage = Detailpage}
                              onCloseCall={() => {
                                  this.setState({modalKey: uuid()})
                              }}
                             dataList={this.state.data}></Detailpage></>


        )
    }


    //详情页
    getDetailPage(item,index) {
        this.setDetailpage.show(true,item,index)
    }

    handleVisibleChange(record) {
        record.moreVisible = !record.moreVisible;
        this.setState({})
    }
    onChangePage(page, size) {
        console.log(1111)
        this.setState({page: page, size: size}, () => {
            this.getList()
        })
    }

    renderPosition() {
        return (
            <Position backList={this.state.Position}></Position>
        )
    }

    getList() {
        let parms = {};
        if (this.state.selectType.length) {
            parms.suffix = this.state.selectType
        }
        if (this.state.searchText) {
            parms.name = this.state.searchText
        }
        if (this.state.startTime) {
            let creatTime = {
                startTime: this.state.startTime,
                endTime: this.state.endTime
            };
            parms.createTime = creatTime
        }
        this.request({
            url: "/cm-sites-storage-management/zykUpload/uploadPageList?page=" + this.state.page + '&size=' + this.state.size,
            method: "post",
            body: parms,
            contentType: "json",
            callBack: (data) => {
                if(data){
                    this.state.data = data.data;
                    this.state.count =data.count;
                    this.state.selectedRowKeys = [];
                    this.state.selectedRows = [];
                    this.setState({},()=>{
                        $('.ant-pagination-options-quick-jumper').find('input').val('')
                    })
                }

            }
        });
    };
}